import { useQuery } from '@tanstack/react-query';
import { apiGetAllocationsForFinancialDocument } from '../../../../api';
import { FinancialDocumentAllocation } from '../../../../../../models/IncomingInvoices';

export function useAllocations(projectId: string, financialDocumentId: string) {
  return useQuery({
    queryKey: ['allocations', projectId, financialDocumentId],
    queryFn: async () => {
      if (projectId && financialDocumentId) {
        const result = await apiGetAllocationsForFinancialDocument(
          projectId,
          financialDocumentId
        );
        if (result.data) {
          return result.data;
        }
      }
      return [] as FinancialDocumentAllocation[];
    },
  });
}
